import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps, withRouter } from "react-router-dom";

import { OptionalRender } from "../../../components/Common/OptionalRender";
import { PageTitle } from "../../../components/Common/PageTitle";
import OrganizationFeaturesContent from "../../../components/EXPERIMENTAL/OrganizationFeatures/Content";
import FeatureSelect from "../../../components/EXPERIMENTAL/OrganizationFeatures/FeatureSelect";
import { useExperimentalOrganizationFeature } from "../../../components/EXPERIMENTAL/OrganizationFeatures/hooks/useExperimentalOrganizationFeature";
import { FeatureNames } from "../../../components/EXPERIMENTAL/OrganizationFeatures/types/featureNames";
import { useMeWithOrganizationImpersonation } from "../../../hooks/organizationImpersonation";
import { useValidateOrganization } from "../../../hooks/validateUserOrganization";
import { AccountType } from "../../../models/AccountData";
import "./styles.scss";

type IOrganizationFeaturesPageProps = RouteComponentProps<any>;

const OrganizationFeaturesPage: React.FunctionComponent<
  IOrganizationFeaturesPageProps
> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`EXPERIMENTAL_organizationFeaturesPage.${key}`);
  const matchOrganizationId = props.match.params.organizationId;

  const me = useMeWithOrganizationImpersonation();

  useValidateOrganization({
    matchOrganizationId,
    redirectUrlFormat: (orgId) =>
      `/experimental/organizationFeatures/organization/${orgId}`,
  });

  const [selectedFeature, setSelectedFeature] = useState<FeatureNames>(
    FeatureNames.KEYWORD_REVIEW_CROSS_ANALYSIS
  );

  const { data: featureData, generate } = useExperimentalOrganizationFeature(
    selectedFeature,
    me?.organization_id
  );

  const handleGenerate = async () => {
    await generate();
  };

  return (
    <div className="right-content experimental-organization-features-page">
      <div className="top-title-bar">
        <PageTitle text={t("EXPERIMENTAL_organization_features")} />
      </div>
      <div>
        <div className="feature-select-container">
          <FeatureSelect
            feature={selectedFeature}
            onChange={setSelectedFeature}
          />
          <OptionalRender mustBeOneOfRoles={[AccountType.ADMIN]}>
            <button className="btn btn-border" onClick={handleGenerate}>
              {t("generate")}
            </button>
          </OptionalRender>
        </div>
      </div>
      <OrganizationFeaturesContent
        featureName={selectedFeature}
        data={featureData?.data}
      />
    </div>
  );
};

export default withRouter(OrganizationFeaturesPage);
